import { render, staticRenderFns } from "./LeaveWordPage.vue?vue&type=template&id=142b71a2&scoped=true"
import script from "./LeaveWordPage.vue?vue&type=script&lang=js"
export * from "./LeaveWordPage.vue?vue&type=script&lang=js"
import style0 from "./LeaveWordPage.vue?vue&type=style&index=0&id=142b71a2&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b71a2",
  null
  
)

export default component.exports